/**
 * 分校地址重定向
 */

export default function ({ store, req, redirect }) {
  // 客户端环境不执行
  if (process.client) return

  const { locale } = store.state
  if (locale !== 'us') return

  const path = req && req.ctx && req.ctx.path ? req.ctx.path : ''
  const normalizedPath = path.replace(/\/+$/, '') || '/'

  const redirectMap = {
    '/campuses/palo-alto': '/campuses/los-altos',
    '/campuses/belmont': '/campuses/cupertino',
    '/campuses/fremont': '/campuses/cupertino',
    '/grades-prek-2': '/lower-elementary',
    '/magic-math': '/lower-elementary',
    '/magic-math/trial': '/lower-elementary',
    '/grades-3-5': '/upper-elementary',
    '/world-think-cup': '/upper-elementary',
    '/sat': '/middle-school',
    '/ap': '/middle-school',
    '/math-reward-challenge': '/middle-school',
    '/sat/resources': '/middle-school',
    '/thinkmatrix': '/',
    '/campuses': '/',
    '/math-competitions': '/',
    '/resource': '/',
    '/practice': '/',
    '/special-event': '/',
    '/about-us': '/aboutus',
    '/about-think-academy/contact-us': '/aboutus',
    '/our-courses': '/trial-classes',
    '/bm/us-short-term-courses/prek_k': '/trial-classes',
    '/1-to-1-assessment': '/evaluation',
    '/enrollment': '/evaluation',
    '/app_online_evaluation': '/evaluation',
    '/evaluation/share': '/evaluation',
    '/evaluation_wsa': '/evaluation',
    '/resource/texas': '/texas',
    '/amc-8/consultation': '/resources/amc8',
    '/amc-8/resource-download': '/resources/amc8',
    '/early-childhood/cognitive-abilities': '/early-childhood',
    '/math-kangaroo/evaluation': '/math-kangaroo',
    '/resource/secret-resource/2ds4kqv5rn8gow0': '/resources/worksheets',
    '/resource/g3-5-math-excellence': '/resources/worksheets',
    '/secret-resource': '/resources/worksheets',
    '/careers': '/careers/job-listings',
    '/amc-10/resource-download': '/resources/amc10',
    '/early-childhood/thinkit': '/early-childhood',
  }

  const target = redirectMap[normalizedPath]
  if (target) {
    redirect(301, target)
  }
}
